/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 26.09.25
 *
 */
export const DueDateTypeEnum = Object.freeze({
	CUSTOM: "CUSTOM",
	SESSION: "SESSION",
	END_OF_CONTRACT: "END_OF_CONTRACT",
})
